// component
import SignUpRecordListCom from './sign-up-record-list/sign-up-record-list.vue';

export default [
  {
    path: 'list',
    name: 'signUpRecordList',
    component: SignUpRecordListCom,
    meta: {
      title: '报名审核记录',
      breadCrumbShowIndexArr: [0, 2]
    }
  }
];

